var _defs, _path, _path2, _path3, _rect, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuvikAsmLogoFullColorRevLtRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 146.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#37193c;}.cls-1,.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-2{fill:#8e77fb;}.cls-3{fill:#7fb0f6;}.cls-4{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m23.47,47.37h12.43l23.21,61.64h-11.04l-4.87-13.76h-27.11l-4.96,13.76H0l23.46-61.64Zm17.04,39.52l-10.69-30.12h-.17l-11.04,30.12h21.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m68.41,108.65c-2.36-1.35-4.19-3.33-5.48-5.92-1.3-2.59-1.95-5.66-1.95-9.19v-29.43h9.64v27.57c0,3.3.88,5.94,2.65,7.91,1.77,1.97,4.16,2.96,7.17,2.96,2.42,0,4.63-.57,6.64-1.72,2.01-1.15,3.6-2.74,4.78-4.78,1.18-2.03,1.77-4.32,1.77-6.85v-25.1h9.55v44.89h-8.4l-1.24-6.37h-.09c-1.95,2.59-4.28,4.58-6.98,5.96-2.72,1.39-5.87,2.08-9.47,2.08-3.37.01-6.23-.66-8.59-2.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m105.94,64.12h10.08l13.09,36.77h.17l13.18-36.77h10.09l-17.33,44.89h-12.12l-17.16-44.89Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.15,
    y: 64.12,
    width: 9.64,
    height: 44.89
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m175.1,43.79h9.55v39.06h.09l16.8-18.74h11.94l-16.63,17.77,18.13,27.14h-11.24l-13.18-20.59-5.93,6.28v14.32h-9.53V43.79h-.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m70.62,52.9c0-23.85,19.41-43.26,43.26-43.26,11.27,0,21.54,4.33,29.24,11.41-3.05-.92-6.27-1.42-9.61-1.42-18.34,0-33.27,14.92-33.27,33.27h9.65c0-13.03,10.6-23.63,23.63-23.63s22.96,9.94,23.6,22.41c.01.4.03.81.03,1.22h9.65c0-.57-.01-1.14-.04-1.71-.91-28.38-24.26-51.2-52.86-51.2s-52.91,23.73-52.91,52.91h9.65Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 120.22,
    width: 215,
    height: 26.51
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.22,135.47l1.86-.35c.12,1.02.96,1.68,2.09,1.68,1.02,0,1.65-.47,1.65-1.12,0-.53-.42-.84-1.42-1.04l-1.18-.23c-1.88-.36-2.71-1.11-2.71-2.45,0-1.67,1.42-2.75,3.39-2.75,1.78,0,3.15.97,3.37,2.45l-1.83.41c-.11-.82-.74-1.35-1.57-1.35s-1.36.44-1.36,1.05c0,.51.38.8,1.27.97l1.21.23c1.94.32,2.82,1.11,2.82,2.5,0,1.78-1.53,2.86-3.72,2.86s-3.68-1.02-3.87-2.86Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.19,138.02l3.08-8.51h2.5l3.07,8.51h-2.14l-.55-1.67h-3.27l-.55,1.67h-2.14Zm3.06-3.12h2.53l-1.25-3.78h-.02l-1.25,3.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.35,138.02l3.08-8.51h2.5l3.07,8.51h-2.14l-.55-1.67h-3.27l-.55,1.67h-2.14Zm3.06-3.12h2.53l-1.25-3.78h-.02l-1.25,3.78Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.41,135.47l1.86-.35c.12,1.02.96,1.68,2.09,1.68,1.02,0,1.65-.47,1.65-1.12,0-.53-.42-.84-1.42-1.04l-1.18-.23c-1.88-.36-2.71-1.11-2.71-2.45,0-1.67,1.42-2.75,3.39-2.75,1.78,0,3.15.97,3.37,2.45l-1.83.41c-.11-.82-.74-1.35-1.57-1.35s-1.36.44-1.36,1.05c0,.51.38.8,1.27.97l1.21.23c1.94.32,2.82,1.11,2.82,2.5,0,1.78-1.53,2.86-3.72,2.86s-3.68-1.02-3.87-2.86Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.25,138.02v-8.51h2.67l2.49,6.23h.02l2.5-6.23h2.64v8.51h-1.88v-5.97h-.02l-2.43,5.97h-1.66l-2.44-5.96h-.02v5.96h-1.86Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.66,138.02l3.08-8.51h2.5l3.07,8.51h-2.14l-.55-1.67h-3.27l-.55,1.67h-2.14Zm3.06-3.12h2.53l-1.25-3.78h-.02l-1.25,3.78Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m101.42,138.02v-8.51h2.39l3.47,6.06h.02v-6.06h1.94v8.51h-2.4l-3.47-6.05h-.02v6.05h-1.92Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.33,138.02l3.08-8.51h2.5l3.07,8.51h-2.14l-.55-1.67h-3.27l-.55,1.67h-2.14Zm3.06-3.12h2.53l-1.25-3.78h-.02l-1.25,3.78Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.19,133.77c0-2.7,1.83-4.55,4.48-4.55,1.88,0,3.43,1.11,3.85,2.75l-1.88.38c-.27-.81-1.06-1.39-1.98-1.39-1.43,0-2.43,1.15-2.43,2.81s1.12,2.86,2.75,2.86c1.37,0,2.43-.91,2.49-2.16h-3.75v-1.27h5.72c.01.2.02.39.02.6,0,2.7-1.78,4.53-4.54,4.53s-4.73-1.86-4.73-4.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.86,138.02v-8.51h5.99v1.63h-4.01v1.8h3.54v1.45h-3.54v2h4.13v1.64h-6.11Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.28,138.02v-8.51h2.67l2.49,6.23h.02l2.5-6.23h2.64v8.51h-1.88v-5.97h-.02l-2.43,5.97h-1.66l-2.44-5.96h-.02v5.96h-1.86Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m159.29,138.02v-8.51h5.99v1.63h-4.01v1.8h3.54v1.45h-3.54v2h4.13v1.64h-6.11Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.7,138.02v-8.51h2.39l3.47,6.06h.02v-6.06h1.94v8.51h-2.4l-3.47-6.05h-.02v6.05h-1.92Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m182.28,138.02v-6.76h-2.55v-1.74h7.13v1.74h-2.55v6.76h-2.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuvikAsmLogoFullColorRevLtRgb);
export default __webpack_public_path__ + "static/media/Auvik-ASM-Logo-Full-color-Rev-Lt-RGB.b245fd149c78cd9a04c108ba05f9c119.svg";
export { ForwardRef as ReactComponent };